import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navigation from '../Navigation';
import Sidebar from '../Sidebar';
import Projects from '../Projects';
import ProjectDetail from '../Projects/ProjectDetail';
import About from '../About/About';
import headshot from '../../resources/intro/headshot.jpg';
import resumePdf from '../../resources/footer/resume.pdf';
import './App.css';

function AppLayout({ sidebarProps }: { sidebarProps: React.ComponentProps<typeof Sidebar> }) {
  const location = useLocation();
  const isProjectDetail = location.pathname.startsWith('/project/');
  const isAbout = location.pathname === '/about';
  const hideSidebar = isProjectDetail || isAbout;

  return (
    <div className="app-layout">
      {!hideSidebar && <Sidebar {...sidebarProps} />}
      <main className={`main-content ${hideSidebar ? 'main-content-full' : ''}`}>
        <Routes>
          <Route path="/" element={<Projects />} />
          <Route path="/project/:projectLink" element={<ProjectDetail />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  // You can customize these values based on your actual portfolio data
  const sidebarProps = {
    profileImage: headshot,
    name: 'Constanza De Rienzo',
    title: 'Software Engineer',
    education: 'M.S.E. CGGT · UPenn',
    bio: (
      <React.Fragment>
        <p>
          Software engineer with a background in <strong>graphics and game technology</strong>. I
          like the puzzle-solving part of engineering: chasing down a subtle bug, figuring out the
          right way to implement a feature and improving the quality of the code.
        </p>
        <p>Based in Los Angeles.</p>
      </React.Fragment>
    ),
    currentProject: {
      label: 'Currently Building',
      title: 'Portfolio v2',
      description: 'A modern, redesigned portfolio website',
      tags: ['React', 'TypeScript', 'Tailwind CSS']
    },
    links: {
      github: 'https://github.com/constanzaderienzo',
      linkedin: 'https://www.linkedin.com/in/constanza-de-rienzo/',
      email: 'derienzoconstanza@gmail.com',
      resume: resumePdf
    }
  };

  return (
    <Router>
      <div className="App">
        <Navigation />
        <AppLayout sidebarProps={sidebarProps} />
      </div>
    </Router>
  );
}

export default App;
